module.exports = __webpack_public_path__ + "static/img/12.91cc27b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/12.png
// module id = rBgT
// module chunks = 0